// extracted by mini-css-extract-plugin
module.exports = {"box":"_404_box_396Kq","scrollWrapper":"_404_scrollWrapper_93zky","tip":"_404_tip_3YrQj"};